import { Link } from "react-router-dom";

const SRC = "https://protobowl.com/";

export default function QuickRecall() {
  return (
    <div className="flex h-screen flex-col bg-background">
      <div className="flex items-center justify-between border-b border-border px-4 py-2">
        <Link to="/vocab-lab" className="text-sm text-muted-foreground hover:text-foreground">← Vocabulary Lab</Link>
        <h1 className="text-lg font-bold text-foreground">Quick Recall</h1>
        <a href={SRC} target="_blank" rel="noreferrer" className="text-sm text-muted-foreground hover:text-foreground">Open full screen</a>
      </div>
      <iframe src={SRC} title="Quick Recall" className="w-full flex-1 border-0" allow="clipboard-write" />
    </div>
  );
}
